import { CacheReducerState } from "../models/definitions";
import { initialState } from "./CacheInitialState";

export const handleAcceptPlatformAgreement = (
  state = initialState
): CacheReducerState => ({
  ...state,
  loggedInUser: { ...state.loggedInUser, termUpdateRequired: false }
});
